module.exports = __webpack_public_path__ + "img/defi.5a3b91fa.svg";